import { HttpErrorResponse } from '@angular/common/http';
import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { ICategory } from 'app/main/shared/shared/table/components/category-name/category-name.component';
import { AdvanceFilterParamType, IAdvanceFilter } from '../../../shared/advanced-filters/components/advance-filter';
import { IGetSavedListingFiltersResponseDTO } from '../../../shared/save-listing-filters/save-filters.dto';
import { IColumnSettings, ICustomColumn } from '../../../shared/shared/table/components/custom-columns-settings/column-settings';
import { IPlaybooksItemDTO } from '../../legal-hub/dto/playbooks-listening.dto';
import { IGuideLineListFilter } from '../../legal-hub/playbooks/playbook-list/playbook-list.component';
import { IMetadataListDTO } from '../../settings/documentfields/metadata-item.dto';
import { ISearchableRequest } from '../../users/userslisting/dto/get-user-list.dto';
import { IUpdatePreviewColumnFormData } from '../documents.service';
import { DocumentInternalReminder, IDocumentDetailRootDTO, Tag, VisibilityEnum } from '../dto/document-details.dto';
import {
    DocumentTypeCustomBoxesDaum, IDocumentDto, IDocumentListingDto, IDocumentTypesDto, IUserGroupFilter, IUserGroupFilterDto
} from '../dto/document-listing.dto';
import { DocumentStatusesEnum } from '../dto/document-statuses.enum';
import { FilterDocumentStatusesEnum } from '../dto/filter-document-statuses.enum';
import { DocumentsListingFeatureKey } from './document-listing.config';
import { ILinkContract, IUpdateFieldsData } from './document-listing.facade';
import { DocumentViewVariantEnum, IDocumentFilterState, IExportDocumentsRequest } from './document-listing.reducers';
import { IDocumentEntitySettings } from '../document-right-sidebar/document-details/document-details.dto';
import { IGroup, ISection } from '../../settings/documenttype/document-type-settings-modal/document-type-settings.dto';

const scope = `[${DocumentsListingFeatureKey}]`;

export const resetState = createAction(`${scope} Reset state`);
export const fetchDocuments = createAction(`${scope} fetch documents`);
export const fetchDocumentsSucceeded = createAction(`${scope} Fetch Documents Succeeded`, (documentsList: IDocumentListingDto) => ({documentsList: documentsList}));
export const fetchDocumentsFailed = createAction(`${scope} Fetch Documents Failed`, (error: HttpErrorResponse) => ({error}));
export const changePage = createAction(`${scope} Change Page`, (pageNumber: number) => ({pageNumber}));
export const searchChange = createAction(`${scope} Search value changed`, (searchValue: string) => ({searchValue}));
export const fetchDocumentData = createAction(`${scope} Patch Document Data`, (documentId: number) => ({documentId}));
export const fetchDocumentDataSucceeded = createAction(`${scope} Patch Document Data Succeeded`, (document: IDocumentDetailRootDTO) => ({document}));
export const fetchDocumentDataFailed = createAction(`${scope} Patch Document Data Failed`, (error: string) => ({error}));
export const documentsSelected = createAction(`${scope} Document selection changed`, (documents: IDocumentDto[]) => ({documents}));
export const documentClicked = createAction(`${scope} documents clicked`, (documentId: number, rightBarName: string) => ({documentId, rightBarName}));
export const changeActiveView = createAction(`${scope} Change Active View`, (view: DocumentViewVariantEnum) => ({view}));

/** Document index data */
export const documentIndexDataCall = createAction(`${scope} Get Document Index Data`, (documentId: number) => ({ documentId }))
export const documentIndexSucceeded = createAction(`${scope} Document Index Data Succeeded`, (indexData: IDocumentDetailRootDTO) => ({ indexData }))
export const documentIndexFailed = createAction(`${scope} Document Index Data Failed`, (error: string) => ({ error }))


/** Right bar */
export const makeDocumentRevoked = createAction(`${scope} Make Document Revoked`, (documentId: number, status: DocumentStatusesEnum) => ({
    documentId,
    status
}));
export const makeDocumentRevokedSucceeeded = createAction(`${scope} Make Document Document Revoked Succeeded`, (documentId: number, status: DocumentStatusesEnum) => ({
    documentId,
    status
}));
export const makeDocumentRevokedFailed = createAction(`${scope} Make Document Revoked Failed`, (error: string) => ({ error }));

export const updateDocumentStatus = createAction(`${scope} Update Document Status`, (documentId: number, status: DocumentStatusesEnum) => ({
    documentId,
    status
}));
export const updateDocumentStatusSucceeeded = createAction(`${scope} Update Document Status Succeeeded`, (documentId: number, status: DocumentStatusesEnum) => ({
    documentId,
    status
}));
export const updateDocumentStatusFailed = createAction(`${scope} Update Document Status Failed`, (error: string) => ({ error }));

export const updateDocumentStatusFromPusher = createAction(`${scope} Update Document Status From Pusher`, (documentId: number, status: DocumentStatusesEnum, updated_at: string) => ({
    documentId,
    status,
    updated_at
}));

export const updateDocumentType = createAction(`${scope} Update Document Type`, (documentId: number, documentType: IDocumentTypesDto) => ({
    documentId,
    documentType
}));

export const updateDocumentTypeSucceeeded = createAction(`${scope} Update Document Type Succeeeded`, (documentId: number, documentType: IDocumentTypesDto) => ({
    documentId,
    documentType
}));
export const updateDocumentTypeFailed = createAction(`${scope} Update Document Type Failed`, (error: string) => ({ error }));


export const updateCategory = createAction(`${scope} Update Category`, (documentId: number, categoryIds: number[]) => ({
    documentId,
    categoryIds
}));

export const updateCategorySucceeeded = createAction(`${scope} Update Category Succeeeded`, (documentId: number, categories: ICategory[]) => ({
    documentId,
    categories
}));
export const updateCategoryFailed = createAction(`${scope} Update Category Failed`, (error: string) => ({ error }));


export const updateDocumentDueDate = createAction(`${scope} Update Document Due Date`, (documentId: number, due_date: string) => ({
    documentId,
    due_date
}));

export const updateDocumentData = createAction(`${scope} Update Document Data`, (documentId: number, document: IDocumentDto) => ({
    documentId,
    document
}));

export const updateDocumentDueDateSucceeeded = createAction(`${scope} Update Document Due Date Succeeded`, (due_date: string, status: string) => ({ due_date, status }));
export const updateDocumentDueDateFailed = createAction(`${scope} Update Document Due Date Failed`, (error: string | HttpErrorResponse) => ({ error }));

export const updateDocumentVisibility = createAction(`${scope} Update Document Visibility`, (documentId: number, visibility: VisibilityEnum) => ({
    documentId,
    visibility
}));
export const updateDocumentVisibilitySucceeeded = createAction(`${scope} Update Document Visibility Succeeeded`, (documentId: number, visibility: VisibilityEnum) => ({
    documentId,
    visibility
}));
export const updateDocumentVisibilityError = createAction(`${scope} Update Document Visibility Error`, (error: string) => ({ error }));

export const updateTagsInDocument = createAction(`${scope} Update Tags In Document`, (documentId: number, tag: Tag) => ({
    documentId,
    tag
}));
export const updateTagsInDocumentSucceeeded = createAction(`${scope} Update Tags In Document Succeeeded`, (documentId: number, tag: Tag) => ({
    documentId,
    tag
}));
export const updateTagsInDocumentFailed = createAction(`${scope} Update Tags In Document Failed`, (error: string) => ({ error }));
export const updateInternalReminder = createAction(`${scope} Update Internal Reminder`, (reminders: DocumentInternalReminder[]) => ({
    reminders
}));

export const removeTagFromDocument = createAction(`${scope} Remove Tag From Document`, (documentId: number, tag: Tag) => ({
    documentId,
    tag
}));
export const removeTagFromDocumentSucceeeded = createAction(`${scope} Remove Tag From Document Succeeeded`, (tag: Tag) => ({ tag }));
export const removeTagFromDocumentFailed = createAction(`${scope} Remove Tag From Document Failed`, (error: string) => ({ error }));

/** Set contract data from right sidebar */
export const updateFormStatus = createAction(`${scope} Update Current Form Status`, (status: boolean) => ({ status }));
export const updateFormStep = createAction(`${scope} Update Form Step`, (step: number) => ({ step }));
export const updateFormSubmittion = createAction(`${scope} Update Form Submittion`, (submitted: boolean) => ({ submitted }));

export const setContractData = createAction(`${scope} Set Contract Data`, (key: string, contractData: number | string) => ({
    key,
    contractData
}));

export const setCustomBoxes = createAction(`${scope} Set Contract Custom Boxes`, (customBoxes: DocumentTypeCustomBoxesDaum[]) => ({ customBoxes }));

export const connectContract = createAction(`${scope} Set Connected Contracts`, (formData: ILinkContract) => ({ formData }));
export const connectContractSuccess = createAction(`${scope} Set Connected Contracts Success`, (connectedContract: ILinkContract[]) => ({ connectedContract }));
export const connectContractFailure = createAction(`${scope} Set Connected Contracts Failure`, (error: string) => ({ error }));

export const updateContractForm = createAction(`${scope} Update Contract Number`, (key: string, data: string) => ({
    key,
    data
}))

export const updateDocumentName = createAction(`${scope} Update Document Name`, (documentId: number, name: string) => ({
    documentId,
    name
}));
export const updateDocumentNameSuccess = createAction(`${scope} Update Document Name Success`, (documentId: number, name: string) => ({
    documentId,
    name
}));
export const updateDocumentNameFailure = createAction(`${scope} Update Document Name Failure`, (error: string) => ({ error }));
/* Filters **/

export const fetchDocumentTypes = createAction(`${scope} fetch document types data`);
export const fetchDocumentTypesSucceeded = createAction(`${scope} fetch document types data succeeded`, (types: IDocumentTypesDto[]) => ({ types }));
export const fetchDocumentTypesFailed = createAction(`${scope} fetch document types data failed`, (error: string) => ({ error }));
export const setDocumentType = createAction(`${scope} Set Single Document Type`, (documentType: IDocumentTypesDto) => ({ documentType }));

export const fetchUserGroups = createAction(`${scope} fetch user group data`);
export const fetchUsersSucceeded = createAction(`${scope} fetch users succeeded`, (users: {
    users: IUserGroupFilterDto[],
    groups: IUserGroupFilterDto[]
}) => ({ users }));
export const fetchUsersFailed = createAction(`${scope} fetch users data failed`, (error: string) => ({ error }));
export const ownerSearchChanged = createAction(`${scope} Owner Search Changed`, props<{ search: string }>());

export const setPerPageRecords = createAction(`${scope} set documents listing per page records`, (perPageRecords: number) => ({ perPageRecords }));
export const filterByStatus = createAction(`${scope} filter document by status`, (status: FilterDocumentStatusesEnum) => ({ status }));
export const filterByFromDate = createAction(`${scope} filter document by from date`, (date: string) => ({ date }));
export const filterByToDate = createAction(`${scope} filter document by to date`, (date: string) => ({ date }));
export const filterByDocumentType = createAction(`${scope} filter document by type`, (id: number) => ({ id }));
export const filterByUser = createAction(`${scope} filter document by user`, (id: IUserGroupFilter) => ({ id }));
export const filterByCategory = createAction(`${scope} filter document by category`, (id: number) => ({ id }));
export const setBasicDocumentFilters = createAction(`${scope} Set Basic Document Filters`, props<{ filters: Partial<IDocumentFilterState & ISearchableRequest> }>());
export const setAdvancedDocumentFilters = createAction(`${scope} Set Advanced Document Filters`, props<{ filters: Partial<IAdvanceFilter<AdvanceFilterParamType>[]> }>())

export const deleteSelectedDocuments = createAction(`${scope} Delete Selected Documents`);
export const deleteSelectedDocumentsSucceeded = createAction(`${scope} Delete Selected Documents Succeeded`);
export const deleteSelectedDocumentsFailed = createAction(`${scope} Delete Selected Documents Failed`, (error: HttpErrorResponse) => ({ error }));

export const restoreSelectedDocuments = createAction(`${scope} Restore Selected Documents `);
export const restoreSelectedDocumentsSucceeded = createAction(`${scope} Restore Selected Documents  Succeeded`);
export const restoreSelectedDocumentsFailed = createAction(`${scope} Restore Selected Documents Failed`, (error: HttpErrorResponse) => ({ error }));

/*Table options*/
export const fetchCustomColumns = createAction(`${scope} Fetch Custom Columns Documents`);
export const fetchCustomColumnsSucceeded = createAction(`${scope} Fetch Custom Columns Documents Succeeded`, props<{
    columns: ICustomColumn
}>());
export const fetchCustomColumnsFailed = createAction(`${scope} Fetch Custom Columns Documents Failed`, (error: HttpErrorResponse) => ({ error }));

export const updateCustomColumns = createAction(`${scope} Update Custom Columns Documents`,
    props<{
        column_settings: IColumnSettings[],
        skipSkeleton: boolean
    }>()
);
export const updateCustomColumnsSucceeded = createAction(`${scope} Update Custom Columns Documents Succeeded`, props<{
    column_settings: IColumnSettings[]
}>());
export const updateCustomColumnsFailed = createAction(`${scope} Update Custom Columns Documents Failed`, (error: HttpErrorResponse) => ({ error }));

/* Exports */
export const exportCSV = createAction(`${scope} Export`, props<{ format: 'csv' | 'xlsx' }>());
export const exportDocumentsData = createAction(`${scope} Export Documents Data`, props<{
    exportOptions: IExportDocumentsRequest
}>());
export const exportDocumentsDataSuccess = createAction(`${scope} Export Documents Data Success`);
export const exportDocumentsDataFailure = createAction(`${scope} Export Documents Data Failure`, props<{
    error: HttpErrorResponse
}>());

export const deleteDocument = createAction(`${scope} Delete Document`, props<{ documentId: number }>());
export const deleteDocumentSuccess = createAction(`${scope} Delete Document Success`);
export const deleteDocumentFailure = createAction(`${scope} Delete Document Failure`, props<{
    error: HttpErrorResponse
}>());

export const fetchAdvancedFilters = createAction(`${scope} Fetch Advanced Filters`);
export const fetchAdvancedFiltersSuccess = createAction(`${scope} Fetch Advanced Filters Success`, props<{
    metadata: IMetadataListDTO
}>());
export const fetchAdvancedFiltersFailure = createAction(`${scope} Fetch Advanced Filters Failure`, props<{
    error: HttpErrorResponse
}>());

export const advancedFilterSearch = createAction(`${scope} Advanced Filter Search`, props<{ searchString: string }>());
export const addAdvancedFilter = createAction(`${scope} Add Advanced Filter`, props<{
    filter: Omit<IAdvanceFilter<AdvanceFilterParamType>, 'uuid'>
}>());
export const removeAdvancedFilter = createAction(`${scope} Remove Advanced Filter`, props<{
    filter: IAdvanceFilter<AdvanceFilterParamType>
}>());
export const updateAdvancedFilter = createAction(`${scope} Update Advanced Filter`, props<{
    filter: IAdvanceFilter<AdvanceFilterParamType>
}>());

export const onFilterClose = createAction(`${scope} On Filter Close`, props<{
    filter: Partial<IAdvanceFilter<AdvanceFilterParamType>>
}>());

export const restoreFilter = createAction(`${scope} Restore Filter`, props<{
    filterId: number
}>());

export const editFilter = createAction(`${scope} Edit Filter`, props<{
    filter: Partial<IGetSavedListingFiltersResponseDTO>
}>());

export const deleteFilter = createAction(`${scope} Delete Filter`, props<{
    filterId: number
}>());

export const filterCategoriesByDocType = createAction(`${scope} Filter Categories By Doc Type`, props<{
    categories?: number[]
}>());



export const DocumentDetailActions = createActionGroup({
    source: scope,
    events: {
        'Update Document Entity Data': props<{ documentId: number, settings: IDocumentEntitySettings }>(),
        'Update Document Entity Data Success': props<{ settings: Partial<ISection>, categories: ICategory[] }>(),
        'Update Document Entity Data Failure': props<{ error: HttpErrorResponse }>(),

        'Change Document Type': props<{ id: number, documentId: number }>(),
        'Change Document Type Success': props<{ groups: IGroup[] }>(),
        'Change Document Type Failure': props<{ error: HttpErrorResponse }>(),
    }
});


// For Document Preview columns
export const updateDocumentColumnValue = createAction(`${scope} Update Document Column Value`, props<{
    formData: IUpdatePreviewColumnFormData
}>());
export const updateDocumentColumnValueSuccess = createAction(`${scope} Update Document Column Value Success`, props<{
    formData: IUpdatePreviewColumnFormData
}>());
export const updateDocumentColumnValueFailure = createAction(`${scope} Update Document Column Value Failure`, props<{
    error: HttpErrorResponse
}>());



export const updateFieldsData = createAction(`${scope} Update Fields Data`, props<{
    payload: IUpdateFieldsData
}>());
export const updateFieldsDataSuccess = createAction(`${scope} Update Fields Data Success`, props<{
    payload: IUpdateFieldsData
}>());
export const updateFieldsDataFailure = createAction(`${scope} Update Fields Data Failure`, props<{
    error: HttpErrorResponse,
    payload: IUpdateFieldsData
}>());



export const rightBarHigherZindex = createAction(`${scope} Right bar higher z-index`, props<{ higher: boolean }>());

/*Legal Hub*/
export const setLegalHubFilters = createAction(`${scope} Set Legal Hub Filters`, props<{ filters: IGuideLineListFilter }>());
export const selectLegalHubPlaybook = createAction(`${scope} Set Legal Hub Selected Playbook`, props<{ playbook: IPlaybooksItemDTO }>());
export const legalHubSuggestionDestroyed = createAction(`${scope} Legal Hub Suggestion Destroyed`);

export const checkSpecialActions = createAction(`${scope} Check Special Document Actions`, props<{ documentId: number }>());
export const updateSpecialActions = createAction(`${scope} Update Special Document Actions`, props<{ action: string | null }>());

export const resendToMetodika = createAction(`${scope} Resend To Metodika`, props<{ documentId: number }>());
export const resendToMetodikaSuccess = createAction(`${scope} Resend To Metodika Success`);
export const resendToMetodikaFailure = createAction(`${scope} Resend To Metodika Failure`, props<{ error: HttpErrorResponse }>());

export const getPlaybookSelection = createAction(`${scope} Get Playbook Selection`, props<{ documentId: number }>());
export const getPlaybookSelectionSuccess = createAction(`${scope} Get Playbook Selection Success`, props<{ selectedPlaybook: IPlaybooksItemDTO }>());
export const getPlaybookSelectionFailure = createAction(`${scope} Get Playbook Selection Failure`,(error: HttpErrorResponse) => ({error}));


export const setPlaybookSelection = createAction(`${scope} Set Playbook Selection`, props<{ documentId: number,playbookId:number }>());
export const setPlaybookSelectionSuccess = createAction(`${scope} Set Playbook Selection Success`, props<{ selectedPlaybook: IPlaybooksItemDTO }>());
export const setPlaybookSelectionFailure = createAction(`${scope} Set Playbook Selection Failure`,(error: HttpErrorResponse) => ({error}));
